module.exports = __webpack_public_path__ + "img/hematology2.4cee19de.png";